import {Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {MatLegacyTooltip as MatTooltip} from '@angular/material/legacy-tooltip';
import {AppHelper} from '@app/core/app.helper';

@Directive({
    selector: '[appShowTooltip]'
})
export class ShowTooltipDirective implements OnInit, OnDestroy {
    @Input('appShowTooltip') public searchTerm: string = null;

    constructor(
        private readonly el: ElementRef,
        private readonly toolTop: MatTooltip
    ) {
    }

    /** Подписка на изменения в элементе */
    #mutationObserver: MutationObserver;

    public ngOnInit(): void {
        let el: HTMLElement;
        const domEl: HTMLElement = this.el.nativeElement;
        switch (this.searchTerm) {
            case null:
                el = domEl;
                break;
            case 'parent':
                el = domEl.parentElement;
                break;
            default:
                el = domEl.querySelector(this.searchTerm);
        }

        this.#mutationObserver = new MutationObserver(() => {
            const flag = AppHelper.isEllipsisActive(el);
            this.toolTop.disabled = !flag;
        });

        if (el) {
            this.#mutationObserver.observe(el, {
                subtree: true, // поддерево
                characterData: true // изменение текстовых данных
            });
        }
    }

    ngOnDestroy(): void {
        this.#mutationObserver.disconnect();
    }

}
